import { render, staticRenderFns } from "./ProductStockPicker.vue?vue&type=template&id=0160868f&scoped=true&"
import script from "./ProductStockPicker.vue?vue&type=script&lang=ts&"
export * from "./ProductStockPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStockPicker.vue?vue&type=style&index=0&id=0160868f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160868f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VCheckbox,VDivider,VIcon})
